import Lenis from 'lenis';
import { SCROLL } from '../app.config.js';
import gsap from '@gsap/business';
import { ScrollTrigger } from '@gsap/business/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default class Scroller {

  constructor() {
    SCROLL && this.init();
  }

  init() {
    this.lenis = new Lenis({
      duration: 1,
      orientation: 'vertical',
      gestureOrientation: 'vertical',
      smoothWheel: true,
      wheelMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    });

    // Sync ScrollTrigger with Lenis' scroll updates.
    this.lenis.on('scroll', ({ scroll }) => {
      ScrollTrigger.update
      if (scroll > 200) {
        document.body.classList.add('_scrolled')
      } else {
        document.body.classList.remove('_scrolled')
      }
    });

    // Ensure GSAP animations are in sync with Lenis' scroll frame updates.
    gsap.ticker.add(time => {
        this.lenis.raf(time * 1000); // Convert GSAP's time to milliseconds for Lenis.
    });
    
    // Turn off GSAP's default lag smoothing to avoid conflicts with Lenis.
    gsap.ticker.lagSmoothing(0);
  }

  start() {
    this.lenis.start();
  }

  stop() {
    this.lenis.stop();
  }

  toggle() {
    this.lenis.isStopped ? this.lenis.start() : this.lenis.stop();
  }

  scrollTo(n, immediate) {
    this.lenis.scrollTo(n, { immediate: immediate });
  }
}
